import React from "react";
import "./App.css";
import TopBar from "./components/TopBar";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import WhyChooseUs from "./components/WhyChooseUs";
import HistorySection from "./components/HistorySection";
import DoctorsSection from "./components/DoctorsSection";
import GallerySection from "./components/GallerySection";
import Footer from "./components/Footer";
import FloatingCallButton from "./components/FloatingCallButton";

function App() {
  return (
    <div className="App">
      <TopBar />
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <WhyChooseUs />
      <HistorySection />
      <DoctorsSection />
      <GallerySection />
      <Footer />
      <FloatingCallButton />
    </div>
  );
}

export default App;
